module.exports = __webpack_public_path__ + "static/media/RR_LT_06.01768ffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/pants/RR_LT_06.png
// module id = 85
// module chunks = 0